'use client'

import { Button, Input, MINIMAL_FILTER_FIELD_CLASS, cn } from '@yeshuman/sdk'
import type { FormEvent, ReactNode } from 'react'
import { Loader2, Mail } from 'lucide-react'


export type InviteByEmailFieldProps = {
  value: string
  onChange: (value: string) => void
  onSubmit: (event: FormEvent<HTMLFormElement>) => void
  isSubmitting?: boolean
  disabled?: boolean
  submitDisabled?: boolean
  placeholder?: string
  submitLabel?: string
  submittingLabel?: string
  inputId?: string
  'aria-label'?: string
  className?: string
  /** Feedback / match state under the input row. */
  children?: ReactNode
  onEmailBlur?: () => void
}

/** Shared email + Send invite shell for Team settings and job Invite tab. */
export function InviteByEmailField({
  value,
  onChange,
  onSubmit,
  isSubmitting = false,
  disabled = false,
  submitDisabled = false,
  placeholder = 'Invite by email',
  submitLabel = 'Send invite',
  submittingLabel = 'Sending…',
  inputId,
  'aria-label': ariaLabel = 'Invitee email',
  className,
  children,
  onEmailBlur,
}: InviteByEmailFieldProps) {
  const controlsDisabled = disabled || isSubmitting

  return (
    <form onSubmit={onSubmit} className={cn('space-y-3', className)}>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        <Input
          id={inputId}
          type="email"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          onBlur={onEmailBlur}
          disabled={controlsDisabled}
          aria-label={ariaLabel}
          autoComplete="email"
          className={cn(MINIMAL_FILTER_FIELD_CLASS, 'flex-1')}
        />
        <Button type="submit" size="sm" disabled={controlsDisabled || submitDisabled}>
          {isSubmitting ? (
            <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden />
              {submittingLabel}
            </>
          ) : (
            <>
              <Mail className="mr-2 h-4 w-4" aria-hidden />
              {submitLabel}
            </>
          )}
        </Button>
      </div>
      {children}
    </form>
  )
}
